import styles from "../../styles/components/searchFigma/ResultListItemMobile.module.css";
import Goto from "../../components/gotoFigmaMobile";
import { logoUrl } from "../../components/search";
export default function ResultListItemMobile({
  parts,
  lifecycle,
  capitalize,
  isLogin,
  keyword,
  member,
}) {
  return (
    <div className="frame0">
      {parts.map((part, index) => (
        <div className={styles.productList}>
          <div className={styles.productInfoOutFrame}>
            <div className={styles.productInfoGroup}>
              {/* image */}
              {/* ✅ 이미지 */}
              {part.image_origin ? (
                // ✅ 실제 이미지가 있는 경우
                <img
                  src={part.image_origin}
                  alt={part.name || "image"}
                  className={styles.image}
                  onError={(e) => {
                    e.target.src = "/images/noimageKO.jpg";
                  }}
                />
              ) : (
                // 🚫 이미지가 없는 경우 (no_image)
                <img
                  src="/images/noimageKO.jpg"
                  alt="이미지 준비중"
                  className={styles.image}
                />
              )}

              {/* productInfo */}
              <div className={styles.productInfo}>
                <div className={`${styles.manufacturer} caption2`}>
                  {" "}
                  {part.manufacturername_str}
                </div>

                {/* productNameLifecycleGroup */}
                <div className={styles.productNameLifecycleGroup}>
                  <div className={`${styles.productName} body1`}>
                    {" "}
                    {part.pn}
                  </div>
                  <div className={styles.line5}></div>
                  <img
                    src={lifecycle(part.LC)}
                    className={styles.lifecycle}
                  ></img>
                </div>

                {/* summary */}
                <div className={`${styles.summary} caption2`}>
                  {capitalize(part.description)}
                </div>
              </div>
            </div>
          </div>

          {/* productDetailGroup */}
          <div className={styles.productDetailGroup}>
            {part.price.map((priceItem, idx) => (
              <div className={styles.productDetailOutFrame}>
                {/* productDetail */}
                <div className={styles.productDetail}>
                  {/* productDetailPriceDeliveryGroup */}
                  <div className={styles.productDetailPriceDeliveryGroup}>
                    {/* distributorIcon */}
                    {logoUrl(priceItem) ===
                    "/images/brand/search/arrow_logo.png" ? (
                      <img
                        src={logoUrl(priceItem)}
                        className={styles.distributorIconArrow}
                      />
                    ) : logoUrl(priceItem) ===
                      "/images/brand/search/digikey_logo.png" ? (
                      <img
                        src={logoUrl(priceItem)}
                        className={styles.distributorIconDigikey}
                      />
                    ) : (
                      <img
                        src={logoUrl(priceItem)}
                        className={styles.distributorIcon}
                      />
                    )}

                    {/* deliveryBox */}
                    <div className={styles.deliveryBox}>
                      <div className={styles.price}>
                        {priceItem.source === "partner" ? (
                          <>
                            <div className={`${styles.specialRed} caption2`}>
                              특가
                            </div>
                          </>
                        ) : // 상시할인이 들어가는 회원은 회원혜택가 노출
                        member > 1 || isLogin == 0 ? (
                          <>
                            <div className={`${styles.specialBlue} caption2`}>
                              혜택가
                            </div>
                          </>
                        ) : (
                          // 상시할인이 들어가지 않으면 회원(일반회원,비회원)은
                          <>
                            {/* <div className={styles.special}>일반가</div> */}
                          </>
                        )}
                        {priceItem.source === "partner" ? (
                          <>
                            <div className={`${styles.specialRedWon} body1`}>
                              {priceItem.price > 0
                                ? member > 1 || isLogin == 0
                                  ? // 상시할인이 들어가는 회원은 회원혜택가 노출
                                    // 상시할인이 들어가지 않으면 회원은 일반회원가 노출
                                    `${priceItem.hook_price.toLocaleString()}원`
                                  : `${priceItem.price.toLocaleString()}원`
                                : "맞춤단가"}
                            </div>
                          </>
                        ) : // 상시할인이 들어가는 회원은 회원혜택가 노출
                        member > 1 || isLogin == 0 ? (
                          <>
                            <div className={`${styles.specialBlueWon} body1`}>
                              {priceItem.price > 0
                                ? member > 1 || isLogin == 0
                                  ? // 상시할인이 들어가는 회원은 회원혜택가 노출
                                    // 상시할인이 들어가지 않으면 회원은 일반회원가 노출
                                    `${priceItem.hook_price.toLocaleString()}원`
                                  : `${priceItem.price.toLocaleString()}원`
                                : "맞춤단가"}
                            </div>
                          </>
                        ) : (
                          // 상시할인이 들어가지 않으면 회원(일반회원,비회원)은
                          <>
                            <div className={`${styles.specialWon} body1`}>
                              {priceItem.price > 0
                                ? member > 1 || isLogin == 0
                                  ? // 상시할인이 들어가는 회원은 회원혜택가 노출
                                    // 상시할인이 들어가지 않으면 회원은 일반회원가 노출
                                    `${priceItem.hook_price.toLocaleString()}원`
                                  : `${priceItem.price.toLocaleString()}원`
                                : "맞춤단가"}
                            </div>
                          </>
                        )}
                      </div>

                      <div className={styles.deliveryDate}>
                        <div className={styles.deliveryIconWrap}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M23.1966 10.2188L21.8841 6.9375C21.7727 6.65973 21.5804 6.42184 21.3321 6.25467C21.0839 6.08751 20.7912 5.99878 20.4919 6H17.25V5.25C17.25 5.05109 17.171 4.86032 17.0303 4.71967C16.8897 4.57902 16.6989 4.5 16.5 4.5H2.25C1.85218 4.5 1.47064 4.65804 1.18934 4.93934C0.908035 5.22064 0.75 5.60218 0.75 6V16.5C0.75 16.8978 0.908035 17.2794 1.18934 17.5607C1.47064 17.842 1.85218 18 2.25 18H3.84375C4.00898 18.6453 4.38428 19.2173 4.91048 19.6257C5.43669 20.0342 6.08387 20.2559 6.75 20.2559C7.41613 20.2559 8.06331 20.0342 8.58952 19.6257C9.11572 19.2173 9.49102 18.6453 9.65625 18H14.3438C14.509 18.6453 14.8843 19.2173 15.4105 19.6257C15.9367 20.0342 16.5839 20.2559 17.25 20.2559C17.9161 20.2559 18.5633 20.0342 19.0895 19.6257C19.6157 19.2173 19.991 18.6453 20.1562 18H21.75C22.1478 18 22.5294 17.842 22.8107 17.5607C23.092 17.2794 23.25 16.8978 23.25 16.5V10.5C23.2501 10.4037 23.232 10.3083 23.1966 10.2188ZM6.75 18.75C6.45333 18.75 6.16332 18.662 5.91665 18.4972C5.66997 18.3324 5.47771 18.0981 5.36418 17.824C5.25065 17.5499 5.22094 17.2483 5.27882 16.9574C5.3367 16.6664 5.47956 16.3991 5.68934 16.1893C5.89912 15.9796 6.16639 15.8367 6.45736 15.7788C6.74834 15.7209 7.04994 15.7506 7.32403 15.8642C7.59811 15.9777 7.83238 16.17 7.9972 16.4166C8.16203 16.6633 8.25 16.9533 8.25 17.25C8.25 17.6478 8.09196 18.0294 7.81066 18.3107C7.52936 18.592 7.14782 18.75 6.75 18.75ZM2.25 12V6H15.75V12H2.25ZM17.25 18.75C16.9533 18.75 16.6633 18.662 16.4166 18.4972C16.17 18.3324 15.9777 18.0981 15.8642 17.824C15.7506 17.5499 15.7209 17.2483 15.7788 16.9574C15.8367 16.6664 15.9796 16.3991 16.1893 16.1893C16.3991 15.9796 16.6664 15.8367 16.9574 15.7788C17.2483 15.7209 17.5499 15.7506 17.824 15.8642C18.0981 15.9777 18.3324 16.17 18.4972 16.4166C18.662 16.6633 18.75 16.9533 18.75 17.25C18.75 17.6478 18.592 18.0294 18.3107 18.3107C18.0294 18.592 17.6478 18.75 17.25 18.75ZM17.25 9.75V7.5H20.4919L21.3919 9.75H17.25Z"
                              fill="#B6BCC9"
                            />
                          </svg>
                        </div>

                        <div className={styles.deliveryTextWrap}>
                          <div className={`${styles.deliveryText} caption1`}>
                            {priceItem.recent_period + priceItem.add_days !== 0
                              ? `${priceItem.recent_period}~${
                                  priceItem.recent_period + priceItem.add_days
                                }일`
                              : "미정"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* productDetailCountGroup */}
                  <div className={styles.productDetailCountGroup}>
                    {/* stockMoqBox */}
                    <div className={styles.stockMoqBox}>
                      <div className={`${styles.stockMoqBoxText} caption2`}>
                        재고 {priceItem.stock.toLocaleString() || 0}개 · MOQ{" "}
                        {priceItem.moq.toLocaleString() || 0}개
                      </div>
                    </div>

                    {/* purchaseTag */}
                    <Goto
                      pics={priceItem}
                      data={part}
                      isLoginCheck={isLogin}
                      keyword={keyword}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
